import { Form } from 'factorial-form'

import type ContractFlowStep from './ContractFlowStep'

class ContractFlow {
  private _steps: ContractFlowStep[]
  private _currentStepNumber: number

  constructor(steps: ContractFlowStep[], initialStepNumber = 0) {
    this._steps = steps
    this._currentStepNumber = initialStepNumber
  }

  get steps(): ContractFlowStep[] {
    return this._steps
  }

  get currentStep(): ContractFlowStep {
    return this._steps[this._currentStepNumber]!
  }

  get currentStepNumber(): number {
    return this._currentStepNumber
  }

  set currentStepNumber(stepNumber: number) {
    this._currentStepNumber = stepNumber
  }

  getStep(stepNumber: number): ContractFlowStep {
    return this._steps[stepNumber]!
  }

  trackSubmit(form: Form) {
    this.currentStep.trackSubmit(form)
  }

  trackExit() {
    this.currentStep.trackExit(this._currentStepNumber + 1)
  }

  nextStep(form: Form) {
    if (this.hasNextStep()) this._currentStepNumber++

    this.currentStep.trackNext(form, this._currentStepNumber)

    return this._currentStepNumber
  }

  previousStep(form: Form) {
    if (this.hasPreviousStep()) this._currentStepNumber--

    this.currentStep.trackBack(form, this._currentStepNumber)

    return this._currentStepNumber
  }

  hasNextStep(): boolean {
    return this._steps.length > this._currentStepNumber + 1
  }

  hasPreviousStep(): boolean {
    return this._currentStepNumber > 0
  }

  isLastStep(): boolean {
    return this._steps.length === this._currentStepNumber + 1
  }
}

export default ContractFlow
